<div class="text-center">
	<h4 class="mb-5">Are you sure you want to remove this jurisdiction?</h4>
	<p>
		All selected departments and related documents will be deleted from this
		file.
	</p>

	<div class="flex justify-between mt-10">
		<app-button btn="secondary" class="mr-5" (click)="onCancel()" size="small"
			>Keep</app-button
		>
		<app-button btn="primary" size="small" (click)="onAccept()"
			>Yes, remove</app-button
		>
	</div>
</div>
